import { Component, Input, OnInit } from '@angular/core';
import { RequirementStatusDto } from '../../../../../models/job-unit-requirements.model';

import { UntilDestroy } from '@ngneat/until-destroy';
import { JobQualificationsChangeTypeEnum } from '../../../enums/job-qualifications-change-type.enum';
import { JobQualificationChange } from '../../../models/job-qualification-change.model';
import { NullDashPipe } from 'src/app/shared/pipes/null-dash.pipe';
import { NgIf } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'nova-job-qualifications-required-type-change',
    templateUrl: './job-qualifications-required-type-change.component.html',
    styleUrls: ['./job-qualifications-required-type-change.component.scss'],
    standalone: true,
    imports: [NgIf, NullDashPipe]
})
export class JobQualificationsRequiredTypeChangeComponent implements OnInit {
    @Input()
    change: JobQualificationChange<RequirementStatusDto>;

    @Input()
    noteChange?: JobQualificationChange<string>;

    changeType = JobQualificationsChangeTypeEnum;
    requiredTypeChangeOriginalValue?: string;
    requiredTypeChangeNewValue?: string;

    ngOnInit(): void {
        this.translateValues();
    }

    translateValues() {
        this.requiredTypeChangeOriginalValue = this.translateExperience(this.change?.originalValue);
        this.requiredTypeChangeNewValue = this.translateExperience(this.change?.newValue);
    }

    translateExperience(requirement: RequirementStatusDto) {
        return !requirement || requirement.isNoneOrNull || requirement.isNA
            ? null
            : requirement.value.replace(/^is/, '');
    }
}
